module.exports = __webpack_public_path__ + "static/media/nz.81d9c76f.svg";